<template>
  <div class="animated fadeIn">
    <b-alert
    dismissible
    :show="showDismissibleAlert"
    :variant="alertVariant"
    @dismissed="showDismissibleAlert=false">{{ alertMessage }}</b-alert>
    <div class="row">
      <div class="col-md-12">
        <b-card>
          <div class="row">
              <div class="col-sm-5">
                  <h4 class="card-title mb-0">
                    Management<small class="text-muted"> upload to create shipments</small>
                  </h4>
              </div><!--col-->

              <div class="col-sm-7">

              </div><!--col-->
          </div><!--row-->
          <hr />
          <form>
            <div class="form-group row">
              <label for="inputCourierName" class="col-sm-2 col-form-label">Courier Name</label>
              <div class="col-sm-6">
                <select class="form-control" v-model="selectedCourierId" @change="this.queryAftershipCouriers">
                  <option value="">-- {{ $t('general.input.please_select_courier') }} --</option>
                  <option v-for="(courier, index) in couriers" :value="courier.id" :key="index">{{ courier.name }}</option>
                </select>
              </div>
            </div>
            <div class="form-group row">
              <label for="inputCourierName" class="col-sm-2 col-form-label">Aftership Courier Slug</label>
              <div class="col-sm-6">
                <select v-model="selectedAftershipCourierId" class="form-control" required>
                  <option value="">-- Please Select Aftership Courier Slug --</option>
                  <option v-for="(item, index) in aftershipCouriers" :value="item.id" :key="index">{{item.slug}} </option>
                </select>
              </div>
            </div>
            <div class="form-group row">
              <label for="costFile" class="col-sm-2 col-form-label">Shipments File</label>
              <div class="col-sm-8">
                <label class="file">
                  <input type="file" name="file" id="file" @change="fileChange($event.target.name, $event.target.files)">
                  <span class="file-custom"></span>
                </label>
                <small id="costFile" class="form-text text-danger">
                  Click <a href="https://oms.lme-ecom.com/download/deliverShipmentTemplate.xlsx" class="font-weight-bold" target="_blank"> HERE </a> to get shipment tempalte
                </small>
              </div>
            </div>
            <div slot="footer">
              <b-button type="submit" size="sm" @click.stop.prevent="handleUpload" variant="primary"><i class="fa fa-dot-circle-o"></i> Submit</b-button>
            </div>
           </form>
        </b-card>
      </div>
    </div>
    <loading-panel v-if="showLoadingPanel"></loading-panel>
  </div>
</template>

<script>
import loadingPanel from '@/components/LoadingPanel'

export default {
  name: 'UploadDeliveryShipments',
  beforeCreate () {
    this.axios.get('delivery/shipment/upload').then(response => {
      if (response.data && response.data.couriers) {
          this.couriers = response.data.couriers
        } else {
          this.$swal({
            title: 'You have not set services',
            text: 'Please contact LME IT to create service First!',
            icon: 'warning',
            animation: false,
            customClass: 'animated tada'
          })
        }
    }).catch(error => {
      console.log(error)
    })
  },
  components: {
    loadingPanel
  },
  data () {
    return {
      showLoadingPanel: false,
      showDismissibleAlert: false,
      alertVariant: '',
      alertMessage: '',
      file: '',
      couriers: [],
      aftershipCouriers: [],
      selectedCourierId: '',
      selectedAftershipCourierId: '',
      formData: new FormData()
    }
  },
  methods: {
    fileChange (fileName, fileList) {
      if (!fileList.length) {
        return
      }
      this.formData.append(fileName, fileList[0], fileList[0].name)
    },
    queryAftershipCouriers () {
      this.selectedAftershipCourierId = ''
      if (this.selectedCourierId && this.selectedCourierId === 12) {
        this.axios.get('aftership-courier/').then(response => {
          if (response && response.data !== null) {
            this.aftershipCouriers = response.data
          }
        }).catch(error => {
          this.showAlert('danger', error.data.message)
        })
      } else {
        this.aftershipCouriers = []
      }
    },
    showAlert (alertVariant, message) {
      this.showDismissibleAlert = true
      this.alertVariant = alertVariant
      this.alertMessage = message
    },
    handleUpload () {
      var config = {
        onUploadProgress: function () {
          // var percentCompleted = Math.round( (progressEvent.loaded * 100) / progressEvent.total )
        }
      }
      if( this.formData.courier_id === undefined){
        this.formData.append('courier_id', this.selectedCourierId)
      }
      this.formData.append('aftership_courier_id', this.selectedAftershipCourierId)
      this.showLoadingPanel = true
      this.axios.post('delivery/shipment', this.formData, config)
        .then(() => {
          this.showLoadingPanel = false
          this.$router.push('/delivery/shipment')
        })
        .catch(error => {
          this.showLoadingPanel = false
          this.showAlert('danger', error.data.message)
        })
    }
  }
}
</script>
